import ComponentRegistry from "Fratello/Common/ComponentRegistry";

import CheckoutCollectionPointsWidget from "Fratello/Checkout/Widgets/CollectionPointsWidget";

import CheckoutViewsCollectionPointsView from "../Checkout/Views/CollectionPointsView";
import CheckoutViewsMapView from "../Checkout/Views/MapView";
import CheckoutViewsListView from "../Checkout/Views/ListView";
import CheckoutViewsCollectionPointView from "../Checkout/Views/CollectionPointView";

ComponentRegistry.register({
    CheckoutCollectionPointsWidget,
    CheckoutViewsCollectionPointsView,
    CheckoutViewsCollectionPointView,
    CheckoutViewsMapView,
    CheckoutViewsListView
});



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Components/Checkout.jsx